// (function () {
//     'use strict';

//     angular.module("imApp").factory("poJobLaboursService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getPoJobLabours: function (parms) {
//                 return $ihttp.post({
//                     method: 2597,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
